/* src/app/cost-estimator/ship-service-estimate/ship-service-estimate.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-service-estimate {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.ship-service-estimate .details {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  line-height: 1.5;
  padding-right: 1em;
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .details {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 60%;
  }
}
.ship-service-estimate .details .title {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .details .title {
    width: 40%;
  }
}
.ship-service-estimate .details .title .service-name {
  font-size: 1rem;
  font-weight: 700;
}
.ship-service-estimate .details .title .transit-days {
  font-size: 0.8em;
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .details .title .transit-days {
    font-size: 0.85em;
  }
}
.ship-service-estimate .details .costs {
  font-size: 0.575em;
  color: #707070;
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .details .costs {
    text-align: center;
  }
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .details .costs {
    font-size: 0.8em;
  }
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .details .costs {
    width: 65%;
  }
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .details .costs .accessorial-fee {
    display: block;
  }
}
.ship-service-estimate .details .costs .accessorial-cost {
  display: none;
}
.ship-service-estimate .details .costs .shipping-cost {
  display: none;
}
.ship-service-estimate .summary {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .summary {
    width: 40%;
  }
}
.ship-service-estimate .summary .total {
  font-size: 1.25rem;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.ship-service-estimate .summary .actions {
  display: none;
  margin-left: 1em;
}
@media screen and (min-width: 48rem) {
  .ship-service-estimate .summary .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }
}
.ship-service-estimate .summary .actions .action {
  margin-left: 0.5em;
  width: auto;
  padding: 0 0.5em;
  min-width: 6.25rem;
}
:host {
  width: 100%;
}
/*# sourceMappingURL=ship-service-estimate.component.css.map */
